// Loader.js
import React from 'react';
import './Loader.css';

const Loader = () => {
    return (
        <div className="loader">
            <div className="spinner"></div>
        </div>
    );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/Components/loader/Loader.js